<template>
  <section class="batch-modify">
    <header class="batch-head">
      <div class="crumb">
        <button class="plain" @click="$emit('back')">‹ 返回</button>
        <span>
          商品工作台　›　批量修改　›　
          <strong>货号</strong>
        </span>
      </div>
      <h1>批量修改货号</h1>
      <nav>
        <button v-for="tab in tabs" :key="tab.value" :class="{ active: mode === tab.value }" @click="mode = tab.value">
          {{ tab.label }}
        </button>
      </nav>
    </header>
    <main>
      <section class="panel">
        <div v-if="mode === 'products'" class="picked">
          <button @click="openSelector">选择商品</button>
          <span>
            已选择
            <b>{{ selected.length }}</b>
            个商品
          </span>
        </div>
        <div v-if="mode === 'product_ids'" class="ids">
          <label>抖店商品 ID</label>
          <el-input
            v-model="idsText"
            type="textarea"
            :rows="3"
            placeholder="多个 ID 用逗号、空格或换行分隔，支持 Excel 粘贴" />
        </div>
        <div v-if="mode === 'range'" class="filters">
          <label v-for="field in shownFields" :key="field.key" class="field">
            <span>
              {{ field.label }}
              <small v-if="field.runtime">（需核验数据）</small>
            </span>
            <doudian-category-cascader
              v-if="field.key === 'category_id'"
              v-model="filters.category_id"
              :categories="categories" />
            <el-date-picker
              v-else-if="field.date"
              v-model="filters[field.key]"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始时间"
              end-placeholder="结束时间" />
            <div v-else-if="field.matchKey" class="combined-control">
              <el-select v-model="filters[field.matchKey]" :aria-label="field.label + '匹配方式'">
                <el-option
                  v-for="option in field.matchOptions"
                  :key="option.value"
                  :value="option.value"
                  :label="option.label" />
              </el-select>
              <div v-if="field.range" class="range">
                <input
                  v-model="filters[field.key + '_min']"
                  :aria-label="field.label + '最小值'"
                  placeholder="最小值" />
                <span>~</span>
                <input
                  v-model="filters[field.key + '_max']"
                  :aria-label="field.label + '最大值'"
                  placeholder="最大值" />
              </div>
              <input
                v-else
                v-model="filters[field.key]"
                :aria-label="field.label"
                :disabled="filters[field.matchKey] === 'empty'"
                :placeholder="
                  filters[field.matchKey] === 'empty' ? '无需填写' : field.placeholder || '请输入' + field.label
                " />
            </div>
            <div v-else-if="field.range" class="range">
              <input v-model="filters[field.key + '_min']" placeholder="最小值" />
              <span>~</span>
              <input v-model="filters[field.key + '_max']" placeholder="最大值" />
            </div>
            <el-select v-else-if="field.options" v-model="filters[field.key]" clearable>
              <el-option
                v-for="option in field.options"
                :key="String(option.value)"
                :value="option.value"
                :label="option.label" />
            </el-select>
            <input v-else v-model="filters[field.key]" :placeholder="field.placeholder || '请输入条件'" />
          </label>
        </div>
        <footer v-if="mode === 'range'" class="filter-actions">
          <div class="shops">
            <el-select v-model="shops" multiple collapse-tags placeholder="全部授权抖店（可选）" :disabled="confirming">
              <el-option-group v-if="shopOptions.length" label="抖店">
                <el-option
                  v-for="shop in shopOptions"
                  :key="shop.mer_shop_id"
                  :value="Number(shop.mer_shop_id)"
                  :label="shop.shop_name">
                  {{ shop.shop_name }}
                </el-option>
              </el-option-group>
            </el-select>
          </div>
          <div class="filter-buttons">
            <button class="more-search" @click="more = !more">{{ more ? '收起更多搜索 ▴' : '更多搜索 ▾' }}</button>
            <button :disabled="loading || confirming" @click="loadPreview(1)">查询</button>
            <button class="plain" @click="resetFilters">重置</button>
          </div>
        </footer>
        <p v-if="mode === 'range'" class="hint">
          不同条件同时满足才命中；一个 SKU 满足已设置的 SKU
          条件即可命中商品。条件筛选有些无法直接查询结果，通过数据命中来判断是否符合。
        </p>
      </section>
      <doudian-batch-common-options v-model="commonOptions" :disabled="loading || confirming" />
      <section class="panel methods">
        <h3>
          <i></i>
          修改内容
        </h3>
        <div class="method-body">
          <div v-for="(method, index) in huohaoMethods" :key="method.type" class="rule-row">
            <el-radio v-model="huohaoType" :label="method.type">方式{{ index + 1 }}：{{ method.label }}</el-radio>
            <small>{{ method.tip }}</small>
            <div class="rule-options huohao-controls">
              <el-input
                v-if="method.type === 401"
                v-model="huohaoForm.newHuohao"
                maxlength="200"
                placeholder="请输入新货号" />
              <template v-if="method.type === 402">
                <el-input v-model="huohaoForm.prefix" placeholder="增加前缀内容" />
                <el-input v-model="huohaoForm.suffix" placeholder="增加后缀内容" />
              </template>
              <template v-if="method.type === 403">
                <div v-for="(replace, i) in huohaoForm.replaces" :key="i" class="method-controls">
                  <el-input v-model="replace.find" placeholder="被替换关键词" />
                  <el-input v-model="replace.value" placeholder="替换为" />
                  <button class="plain" @click="huohaoForm.replaces.push({ find: '', value: '' })">添加</button>
                  <button v-if="i" class="plain" @click="huohaoForm.replaces.splice(i, 1)">删除</button>
                </div>
              </template>
              <el-input
                v-if="method.type === 404"
                v-model="huohaoForm.keywords"
                type="textarea"
                :rows="3"
                maxlength="10000"
                placeholder="多个关键词用中英文逗号分隔" />
              <el-radio-group v-if="method.type === 405" v-model="huohaoForm.mode">
                <el-radio label="all">针对全部商品</el-radio>
                <el-radio label="empty">针对货号为空的商品</el-radio>
              </el-radio-group>
            </div>
          </div>
          <p class="hint">仅修改商品属性中的货号；类目不支持货号的商品会跳过。</p>
        </div>
      </section>
      <section v-if="preview" class="panel preview">
        <doudian-batch-preview-notice />
        <header class="preview-summary">
          <span>
            已选择
            <b>{{ mode === 'products' ? selected.length : preview.total }}</b>
            个商品，当前预览
            <b>{{ preview.total }}</b>
            个，已排除 {{ excluded.length }} 个
          </span>
          <button class="plain" @click="preview = null">收起预览</button>
        </header>
        <div class="preview-details">
          <span>
            本页筛选命中 {{ pageCounts.matched || 0 }} 个，筛选待核验 {{ pageCounts.unknown || 0 }} 个；执行时重新判断。
          </span>
          <span>
            本页预计过滤
            {{ preview.page_filter_counts ? preview.page_filter_counts.property_not_supported || 0 : 0 }}
            个（类目不支持货号属性）；筛选命中不等于实际修改。
          </span>
          <span v-if="!previewCurrent" class="warning">条件已变化，请重新预览。</span>
          <span v-if="inactive.length" class="warning">当前不生效：{{ inactiveLabels }}</span>
        </div>
        <div class="table-wrap">
          <table>
            <thead>
              <tr>
                <th>店铺 / 商品</th>
                <th>抖店商品 ID</th>
                <th>原货号</th>
                <th>目标货号</th>
                <th>预计结果</th>
                <th>说明</th>
                <th>排除</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in preview.list" :key="item.id">
                <td>
                  <div class="preview-product">
                    <el-image
                      class="preview-product-image"
                      :src="productImage(item)"
                      :preview-src-list="productImage(item) ? [productImage(item)] : []"
                      fit="cover">
                      <span slot="error">暂无图片</span>
                    </el-image>
                    <div>
                      <small>{{ item.shop_name }}</small>
                      <p>{{ item.product_title }}</p>
                      <strong>{{ productPrice(item) }}</strong>
                    </div>
                  </div>
                </td>
                <td>{{ item.platform_product_id }}</td>
                <td>{{ huohaoValue(item, false) }}</td>
                <td>{{ huohaoValue(item, true) }}</td>
                <td>{{ resultNames[item.preview_result] || item.preview_result }}</td>
                <td>{{ [item.match_reason, item.error_msg].filter(Boolean).join('；') || '—' }}</td>
                <td><el-checkbox :value="excluded.includes(Number(item.id))" @change="exclude(item.id, $event)" /></td>
              </tr>
              <tr v-if="!preview.list.length"><td colspan="7">暂无候选商品</td></tr>
            </tbody>
          </table>
        </div>
        <footer class="preview-pagination">
          <span>共 {{ preview.total }} 条</span>
          <div class="pagination-actions">
            <el-pagination
              small
              layout="prev, pager, next"
              :current-page="preview.page"
              :page-size="preview.limit"
              :total="preview.total"
              @current-change="loadPreview" />
            <span class="pagination-jump">
              前往
              <input v-model.number="previewJump" min="1" type="number" @keyup.enter="jumpPreviewPage" />
              页
            </span>
          </div>
        </footer>
      </section>
    </main>
    <footer class="actions">
      <button class="preview-button" :disabled="loading || confirming" @click="loadPreview(1)">
        {{ loading ? '加载中…' : '修改内容预览' }}
      </button>
      <button class="start" :disabled="loading || confirming || !previewCurrent" @click="createBatch">
        {{ confirming ? '处理中…' : '开始批量修改' }}
      </button>
      <label>
        <input v-model="scheduled" type="checkbox" :disabled="confirming" @change="toggleSchedule" />
        定时执行
      </label>
      <button v-if="scheduled" class="time" :disabled="confirming" @click="openSchedule">
        {{ scheduledAt.slice(0, 16) }}
      </button>
    </footer>
    <div v-if="scheduleVisible" class="schedule-mask">
      <section class="schedule-modal" role="dialog" aria-modal="true" aria-label="定时执行">
        <header>
          <strong>定时执行</strong>
          <button aria-label="关闭" @click="closeSchedule">×</button>
        </header>
        <main>
          <label>
            执行时间
            <el-date-picker
              v-model="scheduleDraft"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              :clearable="false"
              placeholder="请选择执行时间"
              popper-class="product-selector-dialog__popper"
              class="schedule-picker" />
          </label>
        </main>
        <footer>
          <button class="plain" @click="closeSchedule">取消</button>
          <button @click="confirmSchedule">确定</button>
        </footer>
      </section>
    </div>
    <product-selector-dialog
      :visible="selectorVisible"
      :active-tab="selectorTab"
      :products="selectorProducts"
      :selected-ids="draftSelected.map(productId)"
      :loading="selectorLoading"
      :page="selectorPage"
      :page-size="20"
      :page-sizes="[20]"
      :total="selectorTab === 'selected' ? draftSelected.length : selectorTotal"
      :total-pages="selectorPages"
      :jump-page="selectorJump"
      :page-fully-selected="selectorRows.length > 0 && selectorRows.every(isSelected)"
      :product-id="productId"
      :product-key="productId"
      :product-title="productTitle"
      :product-image="productImage"
      :product-price="productPrice"
      @tab-change="changeSelectorTab"
      @close="selectorVisible = false"
      @toggle-product="toggleProduct"
      @toggle-page="togglePage"
      @page-change="changeSelectorPage"
      @jump-input="selectorJump = $event"
      @jump="changeSelectorPage(Number(selectorJump))"
      @confirm="confirmSelected">
      <template #filters>
        <doudian-product-selector-filters
          :value="selectorFilters"
          :shop-id="selectorShopId"
          :shops="shopOptions"
          :categories="categories"
          @shop-change="changeSelectorShop"
          @query="loadSelector(1)" />
      </template>
    </product-selector-dialog>
  </section>
</template>

<script>
import {
  previewDoudianHuohaoBatch,
  createDoudianHuohaoBatch,
  getDoudianCategories,
  getAuthSuccessShopList,
  getProductSelectorProducts
} from '@/api/main/doudianBatchEdit'
import DoudianCategoryCascader from '@/components/DoudianCategoryCascader'
import ProductSelectorDialog from '@/components/ProductSelectorDialog/ProductSelectorDialog'
import DoudianProductSelectorFilters from './DoudianProductSelectorFilters.vue'
import DoudianBatchCommonOptions, {
  describeCommonOptions,
  batchPreviewNotice
} from '@/components/DoudianBatchCommonOptions'
import DoudianBatchPreviewNotice from '@/components/DoudianBatchCommonOptions/PreviewNotice.vue'

import { fields, pairedFields, defaults } from './batchModifyFilters'

export default {
  name: 'BatchModifyHuohao',
  components: {
    DoudianCategoryCascader,
    DoudianProductSelectorFilters,
    ProductSelectorDialog,
    DoudianBatchCommonOptions,
    DoudianBatchPreviewNotice
  },
  data: () => ({
    tabs: [
      { value: 'range', label: '按范围修改' },
      { value: 'products', label: '按商品修改' }
    ],
    mode: 'range',
    fields,
    filters: defaults(),
    more: false,
    shops: [],
    shopOptions: [],
    categories: [],
    idsText: '',
    selected: [],
    excluded: [],
    huohaoMethods: [
      { type: 401, label: '统一设置货号', tip: '将命中商品设置为相同货号' },
      { type: 402, label: '增加货号前后缀', tip: '在原货号前后添加内容' },
      { type: 403, label: '替换货号关键词', tip: '按顺序替换关键词' },
      { type: 404, label: '删除货号关键词', tip: '删除货号中的指定关键词' },
      { type: 405, label: '随机生成货号', tip: '执行时生成并固定随机货号' }
    ],
    huohaoType: 401,
    huohaoForm: {
      newHuohao: '',
      prefix: '',
      suffix: '',
      replaces: [{ find: '', value: '' }],
      keywords: '',
      mode: 'all'
    },
    commonOptions: { auto_generate_size_chart: false, shelf_action: 0 },
    scheduled: false,
    scheduledAt: '',
    scheduleVisible: false,
    scheduleDraft: '',
    previewJump: 1,
    previewNotice: batchPreviewNotice,
    preview: null,
    signature: '',
    loading: false,
    confirming: false,
    previewRequest: 0,
    resultNames: { ready: '本地预计命中', skipped: '预计跳过', failed: '预计失败', unknown: '本地数据不足，待核验' },
    selectorVisible: false,
    selectorTab: 'all',
    selectorLoading: false,
    selectorRows: [],
    selectorPage: 1,
    selectorTotal: 0,
    selectorJump: 1,
    selectorShopId: '',
    selectorFilters: {
      category_id: { level1: [], level2: [], level3: [] },
      platform_product_id: '',
      product_title: '',
      created_at: [],
      tab_status: ''
    },
    draftSelected: [],
    selectorRequest: 0
  }),
  computed: {
    shownFields() {
      return this.fields
        .filter(
          (field) =>
            !Object.values(pairedFields).includes(field.key) &&
            (!field.more || this.more) &&
            (this.mode === 'range' ||
              !['platform_product_id', 'created_at', 'category_id', 'status'].includes(field.key))
        )
        .map((field) =>
          pairedFields[field.key]
            ? {
                ...field,
                matchKey: pairedFields[field.key],
                matchOptions: this.fields.find((item) => item.key === pairedFields[field.key]).options
              }
            : field
        )
    },
    selectorPages() {
      return Math.max(
        1,
        Math.ceil((this.selectorTab === 'selected' ? this.draftSelected.length : this.selectorTotal) / 20)
      )
    },
    selectorProducts() {
      return this.selectorTab === 'selected'
        ? this.draftSelected.slice((this.selectorPage - 1) * 20, this.selectorPage * 20)
        : this.selectorRows
    },
    previewCurrent() {
      return Boolean(this.preview && this.signature === JSON.stringify(this.payload(false)))
    },
    pageCounts() {
      return this.preview ? this.preview.page_match_counts || {} : {}
    },
    inactive() {
      return this.preview ? this.preview.inactive_conditions || [] : []
    },
    inactiveLabels() {
      return this.inactive
        .map((key) => ({ image_appraisal: '标记鉴图', wash_tag: '洗水标吊牌图' }[key] || key))
        .join('、')
    }
  },
  watch: {
    shops: {
      deep: true,
      handler() {
        this.selected = []
        this.excluded = []
      }
    },
    mode() {
      this.excluded = []
      this.preview = null
    }
  },
  mounted() {
    this.loadOptions()
  },
  beforeDestroy() {
    this.previewRequest++
    this.selectorRequest++
  },
  methods: {
    dataOf(response) {
      if (!response || Number(response.code) !== 200) throw new Error(response?.message || '请求失败')
      return response.data
    },
    message(error) {
      return error?.response?.data?.message || error?.message || '请求失败'
    },
    async loadOptions() {
      // 授权店铺接口已在后台筛选抖店，响应不含shop_type，不能据此再次过滤。
      await Promise.all([
        (async () => {
          try {
            const data = this.dataOf(await getAuthSuccessShopList())
            this.shopOptions = (Array.isArray(data) ? data : data.list || data.data || []).filter(
              (shop) => shop.selectable !== false
            )
          } catch (error) {
            this.$message.error(this.message(error))
          }
        })(),
        (async () => {
          try {
            const data = this.dataOf(await getDoudianCategories({ shop_type: 1 }))
            const map = (items) =>
              items.map((item) => ({
                ...item,
                category_id: item.id || item.category_id,
                category_name: item.name || item.category_name,
                children: map(item.children || [])
              }))
            this.categories = map(Array.isArray(data) ? data : data.list || data.data || [])
          } catch (error) {
            this.$message.error(this.message(error))
          }
        })()
      ])
    },
    split(text) {
      return String(text)
        .split(/[,，\s]+/)
        .filter(Boolean)
    },
    payload(schedule = true) {
      const filter = { shop_ids: [...this.shops], excluded_product_ids: [...this.excluded] }
      Object.keys(this.filters).forEach((key) => {
        const value = this.filters[key]
        if (value !== '' && value !== null && !(Array.isArray(value) && !value.length))
          filter[key] = typeof value === 'object' ? JSON.parse(JSON.stringify(value)) : value
      })
      if (filter.platform_product_id) filter.platform_product_id = [...new Set(this.split(filter.platform_product_id))]
      if (this.mode !== 'range') {
        delete filter.status
        delete filter.created_at
        delete filter.category_id
        filter.platform_product_id =
          this.mode === 'products'
            ? [...new Set(this.selected.map((item) => String(item.platform_product_id)))]
            : [...new Set(this.split(this.idsText))]
      }
      Object.keys(filter)
        .filter((key) => /_(min|max)$/.test(key) || ['brand_id', 'freight_id'].includes(key))
        .forEach((key) => {
          if (/_(min|max)$/.test(key)) filter[key] = Number(filter[key])
        })
      const form = this.huohaoForm
      const options =
        this.huohaoType === 401
          ? { newHuohao: form.newHuohao }
          : this.huohaoType === 402
          ? { prefix: form.prefix, suffix: form.suffix }
          : this.huohaoType === 403
          ? { replaces: form.replaces.map((row) => ({ ...row })) }
          : this.huohaoType === 404
          ? { keywords: form.keywords }
          : { mode: form.mode }
      const payload = {
        selection_mode: this.mode,
        product_filter: filter,
        rules: [{ type: this.huohaoType, options }],
        common_options: { ...this.commonOptions }
      }
      if (schedule && this.scheduled) payload.scheduled_at = this.scheduledAt
      return payload
    },
    validate() {
      const form = this.huohaoForm
      if (this.huohaoType === 401 && !form.newHuohao.trim()) throw new Error('请输入新货号')
      if (this.huohaoType === 402 && !form.prefix.trim() && !form.suffix.trim()) throw new Error('请输入前缀或后缀')
      if (
        this.huohaoType === 403 &&
        (!form.replaces.length || form.replaces.length > 100 || form.replaces.some((row) => !row.find.trim()))
      )
        throw new Error('请填写1–100条有效替换规则')
      if (this.huohaoType === 404 && !form.keywords.split(/[,，]+/).some((word) => word.trim()))
        throw new Error('请输入删除关键词')
      const payload = this.payload(false),
        filter = payload.product_filter
      if (this.mode !== 'range' && !filter.platform_product_id.length) throw new Error('请选择商品或输入抖店商品 ID')
      if (
        filter.platform_product_id &&
        (filter.platform_product_id.length > 10000 ||
          filter.platform_product_id.some((id) => !/^[1-9][0-9]{0,199}$/.test(id)))
      )
        throw new Error('商品 ID 必须是数字，最多10000个')
      ;['stock', 'price', 'sales', 'quality'].forEach((key) => {
        const min = filter[key + '_min'],
          max = filter[key + '_max']
        for (const value of [min, max])
          if (
            value !== undefined &&
            (!Number.isFinite(value) || value < 0 || (['stock', 'sales'].includes(key) && !Number.isInteger(value)))
          )
            throw new Error('范围条件必须填写有效的非负数')
        if (min !== undefined && max !== undefined && min > max) throw new Error('范围起点不能大于终点')
      })
      return payload
    },
    async loadPreview(page = 1) {
      if (this.loading || this.confirming) return
      let payload
      try {
        payload = this.validate()
      } catch (error) {
        return this.$message.warning(error.message)
      }
      const signature = JSON.stringify(payload),
        request = ++this.previewRequest
      this.loading = true
      this.signature = ''
      try {
        const data = this.dataOf(await previewDoudianHuohaoBatch({ ...payload, page, limit: 20 }))
        if (request !== this.previewRequest || this._isDestroyed) return
        if (signature !== JSON.stringify(this.payload(false))) return this.$message.warning('条件已变化，请重新预览')
        if (
          !Array.isArray(data?.list) ||
          !Number.isInteger(data.total) ||
          !Number.isInteger(data.page) ||
          !Number.isInteger(data.limit)
        )
          throw new Error('预览响应格式错误')
        this.preview = data
        this.signature = signature
      } catch (error) {
        if (request === this.previewRequest && !this._isDestroyed) this.$message.error(this.message(error))
      } finally {
        if (request === this.previewRequest) this.loading = false
      }
    },
    exclude(id, value) {
      this.excluded = value
        ? [...new Set([...this.excluded, Number(id)])]
        : this.excluded.filter((item) => item !== Number(id))
      this.signature = ''
    },
    resetFilters() {
      this.filters = defaults()
      this.excluded = []
      this.signature = ''
    },
    jumpPreviewPage() {
      const pages = Math.max(1, Math.ceil(this.preview.total / this.preview.limit))
      this.loadPreview(Math.min(pages, Math.max(1, Number(this.previewJump) || 1)))
    },
    formatScheduleTime(date = new Date(Date.now() + 60000)) {
      const pad = (value) => String(value).padStart(2, '0')
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(
        date.getMinutes()
      )}`
    },
    toggleSchedule() {
      if (!this.scheduled) {
        this.scheduledAt = ''
        this.closeSchedule()
      } else if (!this.scheduledAt) this.scheduledAt = this.formatScheduleTime() + ':00'
    },
    openSchedule() {
      this.scheduleDraft = this.scheduledAt.slice(0, 16) || this.formatScheduleTime()
      this.scheduleVisible = true
    },
    closeSchedule() {
      this.scheduleVisible = false
      this.scheduleDraft = ''
    },
    confirmSchedule() {
      const timestamp = new Date(this.scheduleDraft.replace(' ', 'T') + '+08:00').getTime()
      if (
        !/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(this.scheduleDraft) ||
        !Number.isFinite(timestamp) ||
        timestamp <= Date.now()
      )
        return this.$message.warning('请选择未来的执行时间')
      this.scheduledAt = this.scheduleDraft + ':00'
      this.closeSchedule()
    },
    async createBatch() {
      if (this.loading || this.confirming) return
      try {
        this.validate()
        if (!this.previewCurrent) throw new Error('请先按当前条件预览')
        if (!this.preview.total || this.preview.total > 10000) throw new Error('候选商品必须为1–10000件')
        if (
          this.scheduled &&
          (!/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(this.scheduledAt) ||
            new Date(this.scheduledAt.replace(' ', 'T') + '+08:00') <= new Date())
        )
          throw new Error('定时时间必须是北京时间的未来时间')
      } catch (error) {
        return this.$message.warning(error.message)
      }
      const payload = this.payload(),
        frozen = JSON.stringify(payload)
      this.confirming = true
      try {
        await this.$confirm(
          `候选${this.preview.total}件，实际修改以执行时命中为准。\n${this.previewNotice}\n${describeCommonOptions(
            payload.common_options
          )}${this.inactive.length ? '\n以下条件暂不生效：' + this.inactiveLabels : ''}${
            this.scheduled ? '\n执行时间：' + this.scheduledAt : ''
          }`,
          '确认修改'
        )
        if (this._isDestroyed) return
        if (!this.previewCurrent || frozen !== JSON.stringify(this.payload()))
          throw new Error('条件已变化，请重新预览并确认')
        this.dataOf(await createDoudianHuohaoBatch(payload))
        if (!this._isDestroyed) {
          this.$message.success('任务已创建，请查看批量修改记录')
          this.$emit('created')
        }
      } catch (error) {
        if (error !== 'cancel' && error !== 'close' && !this._isDestroyed) this.$message.error(this.message(error))
      } finally {
        this.confirming = false
      }
    },
    huohaoValue(item, after) {
      if (!after && item.property_supported === false) return '类目无货号属性'
      const ready = after
        ? item.new_value_ready === undefined
          ? item.value_ready
          : item.new_value_ready
        : item.value_ready
      if (!ready) return item.property_supported === false ? '不适用' : '本地数据缺失，待核验'
      const value = after ? item.new_huohao : item.old_huohao
      const text = value == null || value === '' ? '未设置' : value
      return after && item.random_example ? text + '（随机示例）' : text
    },
    productId(item) {
      return Number(item.distribute_product_id || item.id)
    },
    productTitle(item) {
      return item.product_title || item.title || ''
    },
    productImage(item) {
      return item.main_image || item.img || ''
    },
    productPrice(item) {
      return item.product_price == null ? '价格待定' : '¥' + Number(item.product_price).toFixed(2)
    },
    isSelected(item) {
      return this.draftSelected.some((row) => this.productId(row) === this.productId(item))
    },
    toggleProduct(item) {
      if (
        !this.isSelected(item) &&
        this.draftSelected.length &&
        Number(this.draftSelected[0].shop_id) !== Number(item.shop_id)
      )
        return this.$message.warning('只能选择同一家店铺的商品')
      this.draftSelected = this.isSelected(item)
        ? this.draftSelected.filter((row) => this.productId(row) !== this.productId(item))
        : [...this.draftSelected, item]
    },
    togglePage() {
      const all = this.selectorRows.every(this.isSelected)
      const shopId = Number(this.draftSelected[0]?.shop_id || this.selectorRows[0]?.shop_id)
      if (!all && this.selectorRows.some((item) => Number(item.shop_id) !== shopId))
        return this.$message.warning('只能选择同一家店铺的商品，请先筛选店铺')
      this.selectorRows.forEach((item) => {
        if (this.isSelected(item) === all) this.toggleProduct(item)
      })
    },
    changeSelectorTab(tab) {
      this.selectorTab = tab
      this.changeSelectorPage(1)
    },
    changeSelectorPage(page) {
      const next = Math.min(this.selectorPages, Math.max(1, Number(page) || 1))
      if (this.selectorTab === 'all') return this.loadSelector(next)
      this.selectorPage = next
      this.selectorJump = next
    },
    changeSelectorShop(shopId) {
      this.selectorShopId = shopId
      this.loadSelector(1)
    },
    openSelector() {
      this.selectorShopId = this.selected[0]?.shop_id || ''
      this.draftSelected = [...this.selected]
      this.selectorTab = 'all'
      this.selectorVisible = true
      this.loadSelector(1)
    },
    async confirmSelected() {
      const shopId = Number(this.draftSelected[0]?.shop_id)
      if (!shopId || this.draftSelected.some((item) => Number(item.shop_id) !== shopId))
        return this.$message.warning('只能选择同一家店铺的商品')
      this.shops = [shopId]
      await this.$nextTick()
      this.selected = [...this.draftSelected]
      this.selectorVisible = false
      this.excluded = []
    },
    async loadSelector(page) {
      const request = ++this.selectorRequest
      this.selectorLoading = true
      try {
        const data = this.dataOf(
          await getProductSelectorProducts({
            page: Math.max(1, page),
            page_size: 20,
            ...Object.fromEntries(
              Object.entries(this.selectorFilters).filter(
                ([, value]) => value != null && value !== '' && (!Array.isArray(value) || value.length)
              )
            ),
            ...(this.selectorShopId ? { shop_ids: [this.selectorShopId] } : {})
          })
        )
        if (request !== this.selectorRequest || this._isDestroyed) return
        if (!Array.isArray(data?.list)) throw new Error('商品响应格式错误')
        this.selectorRows = data.list
        this.selectorPage = Math.max(1, page)
        this.selectorJump = this.selectorPage
        this.selectorTotal = data.pagination?.total ?? data.total
      } catch (error) {
        if (request === this.selectorRequest && !this._isDestroyed) this.$message.error(this.message(error))
      } finally {
        if (request === this.selectorRequest) this.selectorLoading = false
      }
    }
  }
}
</script>

<style scoped src="./batch-modify.css"></style>

<style scoped>
.huohao-controls {
  flex-basis: 100%;
  padding-left: 24px;
}
.huohao-controls > .el-input {
  width: 280px;
  max-width: 100%;
}
.huohao-controls > .el-textarea {
  width: 570px;
  max-width: 100%;
}
</style>
